// extracted by mini-css-extract-plugin
export default {"logo":"MainLogo_logo__x8o67"};